<template>
  <div class="micro">
    <v-head></v-head>
    <div class="micro_ul">
      {{{micro_str}}}
    </div>
    <!--<ul class="micro_ul">
      <li>
        <div class="micro_left">
          <img :src="micro_list.micro_top_left" alt="">
        </div>
        <div class="micro_right">
          <img :src="micro_list.micro_top_right" alt="">
        </div>
      </li>
      <li>
        <div class="micro_left">
          <img :src="micro_list.micro_middle_left" alt="">
        </div>
        <div class="micro_right">
          <img :src="micro_list.micro_middle_right" alt="">
        </div>
      </li>
      <li>
        <div class="micro_left">
          <img :src="micro_list.micro_bottom_left" alt="">
        </div>
        <div class="micro_right">
          <img :src="micro_list.micro_bottom_right" alt="">
        </div>
      </li>
    </ul>-->
    <v-footer></v-footer>
  </div>
</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
        micro_str:"",
       /* micro_list:{
          micro_top_left:"",
          micro_top_right:"",
          micro_middle_left:"",
          micro_middle_right:"",
          micro_bottom_left:"",
          micro_bottom_right:"",
        }*/

      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var url = "http://112.74.184.45:882/";
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsById/265",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222,data)
            _this.micro_str = data.content;
          }
        },
      });
      /*$.ajax({
        type: "get",
        url: "http://112.74.184.45:882/api/getImageByTypeId/19",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
              console.log(3333,data.data);
            for(var i = 0;i<data.data.length;i++){
              _this.micro_list.micro_top_left = url + data.data[2].src;
              _this.micro_list.micro_top_right = url + data.data[1].src;
              _this.micro_list.micro_middle_left = url + data.data[0].src;
              _this.micro_list.micro_middle_right = url + data.data[3].src;
              _this.micro_list.micro_bottom_left = url + data.data[5].src;
              _this.micro_list.micro_bottom_right = url + data.data[4].src;
            }
          }
        },
      });*/
    }
  }
</script>

<style>
  .micro{width:9rem;text-align: center;margin: 0.5rem auto}
  .micro_ul{margin-top: 0.5rem}
  .micro_ul p{margin-bottom: 0.2rem}
  .micro_ul p:nth-child(odd){background-color: #a0a0a0}
  .micro_ul p:nth-child(even){background-color: #bd8c8f}
 /* .micro ul{margin-top: 0.5rem;margin-bottom: 0.2rem}
  .micro_ul li{margin-bottom: 0.2rem}
  .micro_ul li:nth-child(odd){background-color: #a0a0a0}
  .micro_ul li:nth-child(even){background-color: #bd8c8f}
  .micro_left{float: left}
  .micro_right p{font-size: 0.18rem;float: right}*/
  @media screen and (max-width: 30em) and (min-width:20em ){
    .micro{width:100%;text-align: center;margin: 0 auto}
    .micro img{width: 100%;height: auto}
   /* .micro ul{margin-top: 0.5rem;margin-bottom: 0.2rem}
    .micro_ul li:nth-child(odd){background-color: #a0a0a0}
    .micro_ul li:nth-child(even){background-color: #bd8c8f}
    .micro_left{float: none}
    .micro_right p{font-size: 0.18rem;float: none}*/
  }
</style>




// WEBPACK FOOTER //
// micro.vue?75320aa1